import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import {
  isPathForbiddenForGroups,
  getRedirectTargetForForbiddenPath,
} from 'utils/routeAccess';
import {
  getPostLoginRouteForUser,
  isPlatformAdministrator,
} from 'utils/platformAdmin';

/**
 * RoleGuardRoute
 * Guards a route based on user groups before the target component mounts.
 *
 * Props:
 * - component: React component to render when access is allowed
 * - ...rest: any Route props (path, exact, etc.)
 */
const RoleGuardRoute = ({ component: Component, authState = {}, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const { authInfo = {} } = authState;
      const { groups = [] } = authInfo;

      if (isPlatformAdministrator(groups)) {
        return <Redirect to={getPostLoginRouteForUser(groups)} />;
      }

      const pathname = props?.location?.pathname || '';

      if (isPathForbiddenForGroups(pathname, groups)) {
        const redirectTo = getRedirectTargetForForbiddenPath(pathname, groups);
        return <Redirect to={redirectTo} />;
      }

      return <Component {...props} />;
    }}
  />
);

RoleGuardRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  authState: PropTypes.object,
};

const mapStateToProps = ({ authState }) => ({
  authState,
});

export default connect(mapStateToProps)(RoleGuardRoute);
